"use strict";
/**
 * @module Services.Control
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var conversation_id_serialiser_1 = require("./../../conversation/conversation-id-serialiser");
var serialiser_1 = require("./../../serialisers/serialiser");
var topic_control_registration_params_serialiser_1 = require("./topic-control-registration-params-serialiser");
/**
 * Serialiser for {@link TopicControlRegistrationRequest}
 */
var TopicControlRegistrationRequestSerialiserClass = /** @class */ (function (_super) {
    __extends(TopicControlRegistrationRequestSerialiserClass, _super);
    function TopicControlRegistrationRequestSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Write a {@link TopicControlRegistrationRequest} to the stream
     *
     * @param bos    the output stream
     * @param value  the {@link TopicControlRegistrationRequest} to be written
     */
    TopicControlRegistrationRequestSerialiserClass.prototype.write = function (bos, value) {
        topic_control_registration_params_serialiser_1.TopicControlRegistrationParamsSerialiser.write(bos, value.params);
        conversation_id_serialiser_1.CIDSerialiser.write(bos, value.cid);
    };
    return TopicControlRegistrationRequestSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.TopicControlRegistrationRequestSerialiserClass = TopicControlRegistrationRequestSerialiserClass;
/**
 * The {@link TopicControlRegistrationRequestSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.TopicControlRegistrationRequestSerialiser = new TopicControlRegistrationRequestSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/control/topic-control-registration-request-serialiser.js
// module id = 1925
// module chunks = 1